import * as preact from "preact";

import * as modalController from "modalController";
import Dialog from "views/Dialog";

export type ApplyTranscriptMode = "replace-text" | "keep-text";

type Props = {
  filename?: string;
  onChoose: (mode: ApplyTranscriptMode) => void;
};

const options: { mode: ApplyTranscriptMode; label: string; hint: string }[] = [
  {
    mode: "replace-text",
    label: "Replace text and add timings",
    hint: "Replace the document text with the transcript and apply its timings.",
  },
  {
    mode: "keep-text",
    label: "Keep my text, add timings only",
    hint:
      "Map the transcript's timings onto your existing text. Only works if " +
      "the transcript's text closely matches the document.",
  },
];

const ApplyTranscriptDialog = ({ filename, onChoose }: Props) => {
  const handle = (mode: ApplyTranscriptMode) => {
    modalController.cancel(null, true);
    onChoose(mode);
  };

  return (
    <Dialog
      class="applyTranscriptDialog"
      headingIcon="question-sign"
      heading="How should we apply this transcript?"
    >
      {filename && (
        <p>
          From file: <strong>{filename}</strong>
        </p>
      )}
      <ul class="applyTranscriptDialogOptions">
        {options.map(({ mode, label, hint }) => (
          <li key={mode}>
            <button class="prominent" name={mode} onClick={() => handle(mode)}>
              {label}
            </button>
            <p class="applyTranscriptDialogHint">{hint}</p>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export const show = (
  options: { filename?: string },
  onChoose: (mode: ApplyTranscriptMode) => void
) => {
  modalController.show(
    <ApplyTranscriptDialog filename={options.filename} onChoose={onChoose} />
  );
};
